import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";


export const relationsApi = createApi({
    reducerPath: 'relationsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: '/relations/api',
    }),
    tagTypes: ['relations'],
    endpoints: (build) => ({
        getContactUsPage: build.query({
            query: () => ({
                url: '/contact/contactUsPage',
            })
        }),
        sendNewContact: build.mutation({
            query: (data) => ({
                url: '/contact/newContact',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getMembershipGeneratorPage: build.query({
            query: () => ({
                url: '/membership-generator/getMembershipGeneratorPageOld'
            })
        }),
        getClubMemberCertificate: build.mutation({
            query: (data) => ({
                url: '/membership-generator/getClubMemberCertificate',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getMembershipGeneratorCertificatePdf: build.mutation({
            query: (full_name) => ({
                url: '/membership-generator/getClubMemberCertificatePdf',
                method: 'GET',
                params: { full_name },
                responseType: 'blob',
                popupOnError: false,
            })
        }),
        sendClubMemberCertificatePdfByEmail: build.mutation({
            query: (full_name) => ({
                url: '/membership-generator/sendClubMemberCertificatePdfByEmail',
                method: 'GET',
                params: { full_name },
                popupOnError: false,
            })
        }),
        getLegalAdvicePage: build.query({
            query: () => ({
                url: '/legal-advice/legal-advice-page'
            }),
        }),

        getLegalAdviceQuestions: build.query({
            query: () => ({
                url: '/legal-advice/questions'
            })
        }),
        getLegalAdviceQuestion: build.query({
            query: (params) => ({
                url: `/legal-advice/question/${params.question_id}`,
                params
            })
        }),
        submitLegalAdviceQuestion: build.mutation({
            query: (data) => {
                return {
                    url: '/legal-advice',
                    method: 'POST',
                    data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            }
        }),

        getExpertsPage: build.query({
            query: () => ({
                url: '/ask-the-expert/getExpertPage'
            })
        }),

        sendExpertQuestion: build.mutation({
            query: (data) => ({
                url: '/ask-the-expert/askTheExpert',
                method: 'POST',
                data,
            })
        }),

        getSuppliersApplicationPage: build.query({
            query: () => ({
                url: '/suppliers-application/'
            })
        }),

        suppliersApplication: build.mutation({
            query: (data) => ({
                url: '/suppliers-application/newSupplierApplication',
                method: 'POST',
                data,
            })
        }),
        getUsersApplication: build.query({
            query: () => ({
                url: '/user-application'
            })
        }),
        usersApplicationCreate: build.mutation({
            query: (data) => ({
                url: '/user-application/create-user-application',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }),
        signUpForNewsletter: build.mutation({
            query: (data) => ({
                url:  `/newsletter/signUpForNewsletter`,
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }),
        getLandingPage: build.query({
            query: (slug) => ({
                url: `/user-application/${slug}`,
            })
        }),
        executeFlow: build.mutation({
            query: (data) => ({
                url: `/landing-page/execute-flow`,
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        })
    })
})

export const {
    useGetContactUsPageQuery,
    useSendNewContactMutation,
    useGetMembershipGeneratorPageQuery,
    useGetClubMemberCertificateMutation,
    useGetMembershipGeneratorCertificatePdfMutation,
    useSendClubMemberCertificatePdfByEmailMutation,
    useGetLegalAdvicePageQuery,
    useGetLegalAdviceQuestionsQuery,
    useGetLegalAdviceQuestionQuery,
    useSubmitLegalAdviceQuestionMutation,
    useGetExpertsPageQuery,
    useSendExpertQuestionMutation,
    useGetSuppliersApplicationPageQuery,
    useSuppliersApplicationMutation,
    useGetUsersApplicationQuery,
    useUsersApplicationCreateMutation,
    useGetLandingPageQuery,
    useSignUpForNewsletterMutation,
    useExecuteFlowMutation,
} = relationsApi

